import PropTypes from 'prop-types';

export const athleteProps = PropTypes.shape({
  firstname: PropTypes.string,
  name: PropTypes.string,
  location: PropTypes.string,
  avatarUrl: PropTypes.string,
  primarySport: PropTypes.string,
  followingCount: PropTypes.number,
  followUrl: PropTypes.string,
  profileVisibility: PropTypes.string,
  profile: PropTypes.shape({
    full: PropTypes.string,
    large: PropTypes.string
  })
});

export const achievementsProps = PropTypes.arrayOf(
  PropTypes.shape({
    showTrophy: PropTypes.bool,
    spriteName: PropTypes.string,
    description: PropTypes.string,
    timeago: PropTypes.string
  })
);

export const recentActivitiesProps = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    type: PropTypes.string,
    detailedType: PropTypes.string,
    startDateLocal: PropTypes.string,
    distance: PropTypes.string,
    elevation: PropTypes.string,
    movingTime: PropTypes.string,
    images: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string,
        primary: PropTypes.bool,
        caption: PropTypes.string,
        defaultSrc: PropTypes.string,
        squareSrc: PropTypes.string
      })
    ),
    isManual: PropTypes.bool,
    hasGps: PropTypes.bool
  })
);

export const trophiesProps = PropTypes.arrayOf(
  PropTypes.shape({
    url: PropTypes.string.isRequired,
    logo_url: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    teaser: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    challenge_id: PropTypes.number.isRequired,
    effort: PropTypes.string,
    rank: PropTypes.string
  })
);

export const authorizationUrlsProps = PropTypes.shape({
  facebook: PropTypes.string.isRequired,
  google: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired
});

export const analyticsDataProps = PropTypes.shape({
  category: PropTypes.string.isRequired,
  page: PropTypes.string.isRequired
});

export const statsProps = PropTypes.shape({
  monthlyTime: PropTypes.string,
  monthlyDistance: PropTypes.string,
  chartData: PropTypes.arrayOf(
    PropTypes.shape({
      month: PropTypes.string,
      miles: PropTypes.number,
      hours: PropTypes.number,
      elev_gain: PropTypes.number
    })
  )
});

export const athleteDataProps = PropTypes.shape({
  athlete: athleteProps.isRequired,
  achievements: achievementsProps,
  recentActivities: recentActivitiesProps,
  trophies: trophiesProps,
  authorizationUrls: authorizationUrlsProps.isRequired,
  analyticsData: analyticsDataProps.isRequired,
  stats: statsProps
});
